import { cn } from "@/utils";
import { NavLink } from "react-router";
import LogoImage from "@/assets/images/logo_s.png";

interface Props {
	size?: number | string;
	className?: string;
}
function Logo({ size = 50, className }: Props) {
	return (
		<NavLink to="/" className={cn(className)}>
			<img
				src={LogoImage}
				alt="Logo"
				className="object-contain"
				style={
					size
						? {
								width: size,
								padding: "8px",
							}
						: {
								padding: "8px",
							}
				}
			/>
		</NavLink>
	);
}

export default Logo;
